import React from 'react';
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  Typography,
  makeStyles
} from '@material-ui/core';
import useGetRequest from '../../../hooks/useGetRequest';
import UploadFileButton from '../../../components/UploadFileButton';
import uploadToS3 from '../../../utils/uploadToS3';
import FlexbaseHttp from '../../../utils/api';
import Gmail from './Gmail';

const useStyles = makeStyles((theme) => ({
  root: {},
  name: {
    marginTop: theme.spacing(1)
  },
  avatar: {
    height: 100,
    width: 100
  }
}));

function ProfileDetails() {
  const classes = useStyles();

  const { result: user, isLoading, httpRequest: getUser } = useGetRequest({
    url: '/identity/me/',
    initialResult: [],
  });

  if (isLoading) return null;

  const handleChangePicture = (file: any) => {
    uploadToS3(file).then((s3Url) => {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ avatarUrl: any; }' is not assi... Remove this comment to see the full error message
      new FlexbaseHttp('/identity/me/', { avatarUrl: s3Url }).patch().then(() => getUser());
    });
  };

  return (
    <Card className={classes.root}>
      <CardContent>
        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          textAlign="center"
        >
          <Avatar
            className={classes.avatar}
            src={user.avatarUrl}
          />
          <Typography
            className={classes.name}
            gutterBottom
            variant="h3"
            color="textPrimary"
          >
            {`${user.firstName} ${user.lastName}`}
          </Typography>
          <Typography
            color="textPrimary"
            variant="body1"
          >
            {user.email}
          </Typography>
          <Typography
            color="textSecondary"
            variant="body2"
          >
            {user.timezone}
          </Typography>
        </Box>
      </CardContent>
      <CardActions>
        <Box display="flex" flexGrow="1" flexDirection="column">
          <UploadFileButton
            fullWidth
            variant="text"
            onChooseFile={handleChangePicture}
          >
            Change picture
          </UploadFileButton>
          <Box pb={1} />
        </Box>
      </CardActions>
    </Card>
  );
}

export default ProfileDetails;
